// eslint-disable-next-line no-restricted-imports
import dayjs, { ConfigType, ManipulateType, OptionType } from 'dayjs';
import 'dayjs/locale/id';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localizedFormat from 'dayjs/plugin/localizedFormat';

import utc from 'dayjs/plugin/utc';
import { storage } from './Storage';

const lang = storage.get('lang', 'id');

dayjs.extend(customParseFormat);
dayjs.extend(localizedFormat);
dayjs.extend(utc);
dayjs.locale(lang);

// DATE TIME
export const dateTime = (date?: ConfigType, format?: OptionType) => {
  return dayjs(date, format).format('DD MMM YYYY, HH:mm');
};

export const dateTimeLocal = (date?: ConfigType, format?: string) => {
  return dayjs.utc(date, format).local().format('DD MMM YYYY, HH:mm');
};

export const dateTimeUtc = (date?: ConfigType, format?: string) => {
  return dayjs.utc(date, format).format('YYYY-MM-DD HH:mm:ss');
};

export const dateTimeUtcFromGMT7 = (date?: ConfigType, format?: string) => {
  return dayjs(date, format).subtract(7, 'hours').format('YYYY-MM-DD HH:mm:ss');
};

export const dateTimeApiKeySchedule = (date?: ConfigType) => {
  return dayjs
    .utc(date, 'YYYY-MM-DD HH:mm:ss')
    .local()
    .format('D MMM YYYY HH:mm');
};

export const dateTimeUtcApiKeySchedule = (date: ConfigType) => {
  return dayjs(date).utc().format('YYYY-MM-DD HH:mm:ss');
};

// DATE
export const date = (date?: ConfigType, format?: OptionType) => {
  return dayjs(date, format).format('DD MMM YYYY');
};

export const dateGMT7 = (date?: ConfigType, format?: OptionType) => {
  return dayjs(date, format).add(7, 'hours').format('DD MMM YYYY');
};

export const dateLocal = (date?: ConfigType, format?: string) => {
  return dayjs.utc(date, format).local().format('DD MMM YYYY');
};

// TIME
export const time = (date?: ConfigType, format?: OptionType) => {
  return dayjs(date, format).format('HH:mm:ss');
};

export const timeGMT7 = (date?: ConfigType, format?: OptionType) => {
  return dayJs(date, format).add(7, 'hours').format('HH:mm:ss');
};

export const timeLocal = (date?: ConfigType, format?: string) => {
  return dayjs.utc(date, format).local().format('HH:mm:ss');
};

// BE DATE
export const dateBE = (date?: ConfigType, format?: OptionType) => {
  return dayjs(date, format).format('YYYY-MM-DD');
};

// utility date
export const nowToDate = (date?: ConfigType, format?: OptionType) => {
  return dayjs(date, format).toDate();
};

export const minimumDate = (amount: number, unit?: ManipulateType) => {
  return dayjs().subtract(amount, unit).toDate();
};

export const maximumDate = (amount: number, unit?: ManipulateType) => {
  return dayjs().add(amount, unit).toDate();
};

export const now = () => {
  return dayjs();
};

export const dayJs = (date?: ConfigType, format?: OptionType) => {
  return dayjs(date, format);
};

export const isValidDate = (date: ConfigType) => {
  return dayjs(date).isValid();
};
